import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function AdminDashboard() {
  const { logout } = useAuth();
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const s = await axios.get('/admin/stats');
        setStats(s.data.stats);
      } catch {
        setStats(null);
      }
    })();
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/', { replace: true });
  };

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h4">Admin Panel</h1>
        <button className="btn btn-outline-danger" onClick={handleLogout}>Logout</button>
      </div>

      {/* Statistics */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h2 className="h6 text-muted mb-3">Statistics</h2>
          {!stats ? 'Loading...' : (
            <ul className="list-unstyled mb-0">
              <li><strong>Total Users:</strong> {stats.totalUsers}</li>
              <li><strong>Admins:</strong> {stats.admins}</li>
            </ul>
          )}
        </div>
      </div>

      {/* Management Buttons */}
      <div className="row g-3">
        <div className="col-md-4">
          <Link to="/admin/dashboard/users" className="btn btn-outline-primary w-100 py-3 shadow-sm">
            👥 Manage Users
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/news" className="btn btn-outline-success w-100 py-3 shadow-sm">
            📰 Manage Tech News
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/settings" className="btn btn-outline-warning w-100 py-3 shadow-sm">
            ⚙️ Site Settings
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/categories" className="btn btn-outline-info w-100 py-3 shadow-sm">
            📂 Manage News Categories
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/videos" className="btn btn-outline-danger w-100 py-3 shadow-sm">
            🎥 Manage Videos
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/video-categories" className="btn btn-outline-secondary w-100 py-3 shadow-sm">
            🎬 Manage Video Categories
          </Link>
        </div>

        {/* 🔗 لینک‌های جدید برای نشریات */}
        <div className="col-md-4">
          <Link to="/admin/dashboard/publications" className="btn btn-outline-dark w-100 py-3 shadow-sm">
            📖 Manage Publications
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/admin/dashboard/publication-categories" className="btn btn-outline-dark w-100 py-3 shadow-sm">
            🗂️ Manage Publication Categories
          </Link>
        </div>

          {/* ⭐ Projects (لینک جدید) */} 
          <div className="col-md-4"> 
            <Link to="/admin/dashboard/projects" className="btn btn-outline-primary w-100 py-3 shadow-sm">
             🧩 Manage Projects 
             </Link> 
          </div>


      </div>
    </div>
  );
}
